import baseFetch from '../baseFetch';

// eslint-disable-next-line
export const fetchSolunar = async (lat, lon, userDetails = {}) =>
  baseFetch(`solunar?lat=${lat}&lon=${lon}`, userDetails);



// WEBPACK FOOTER //
// ./src/common/api/solunar.js